import React from 'react';
import styles from './ImageAttachment.module.css';

interface ImageAttachmentProps {
  image: File | Blob;
  onRemove: () => void;
  isLoading?: boolean;
}

const ImageAttachment: React.FC<ImageAttachmentProps> = ({ 
  image, 
  onRemove, 
  isLoading = false 
}) => {
  if (!image) return null;

  return (
    <div className={styles.imagePreviewContainer}>
      <div className={`${styles.selectedImagePreview} ${isLoading ? styles.loading : ''}`}>
        <img src={URL.createObjectURL(image)} alt="Selected" />
        {isLoading && (
          <div className={styles.loadingOverlay}>
            <div className={styles.spinner} />
          </div>
        )}
        <button 
          type="button" 
          className={styles.removeImageButton} 
          onClick={onRemove}
          disabled={isLoading}
          aria-label="Remove image"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default ImageAttachment; 